/* esm.sh - applesauce-core@5.2.0/operations/event */
export * from "/*applesauce-core@5.2.0/esnext/operations/event.mjs";
